export const setCookie =  (payload, baseUrl) => {
    return $.ajax({
        url: `${baseUrl}/setCookie`,
        method: 'POST',
        data: payload,
        dataType: 'json',
        xhrFields: { withCredentials: true }
    });
}


// WEBPACK FOOTER //
// ./src/Common/Providers/SetCookieApi.js